"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Balcony", {
  enumerable: true,
  get: function get() {
    return _Balcony["default"];
  }
});
Object.defineProperty(exports, "Bathrobes", {
  enumerable: true,
  get: function get() {
    return _Bathrobes["default"];
  }
});
Object.defineProperty(exports, "Bathroom", {
  enumerable: true,
  get: function get() {
    return _Bathroom["default"];
  }
});
Object.defineProperty(exports, "BathroomFloorScales", {
  enumerable: true,
  get: function get() {
    return _BathroomFloorScales["default"];
  }
});
Object.defineProperty(exports, "Bbq", {
  enumerable: true,
  get: function get() {
    return _Bbq["default"];
  }
});
Object.defineProperty(exports, "Bidet", {
  enumerable: true,
  get: function get() {
    return _Bidet["default"];
  }
});
Object.defineProperty(exports, "BungalowLocation", {
  enumerable: true,
  get: function get() {
    return _BungalowLocation["default"];
  }
});
Object.defineProperty(exports, "BunkBed", {
  enumerable: true,
  get: function get() {
    return _BunkBed["default"];
  }
});
Object.defineProperty(exports, "Butler", {
  enumerable: true,
  get: function get() {
    return _Butler["default"];
  }
});
Object.defineProperty(exports, "Cabinet", {
  enumerable: true,
  get: function get() {
    return _Cabinet["default"];
  }
});
Object.defineProperty(exports, "Canteen", {
  enumerable: true,
  get: function get() {
    return _Canteen["default"];
  }
});
Object.defineProperty(exports, "Carpet", {
  enumerable: true,
  get: function get() {
    return _Carpet["default"];
  }
});
Object.defineProperty(exports, "ChangeOfClothes", {
  enumerable: true,
  get: function get() {
    return _ChangeOfClothes["default"];
  }
});
Object.defineProperty(exports, "ChildrensBed", {
  enumerable: true,
  get: function get() {
    return _ChildrensBed["default"];
  }
});
Object.defineProperty(exports, "Cleaning", {
  enumerable: true,
  get: function get() {
    return _Cleaning["default"];
  }
});
Object.defineProperty(exports, "ClothesDryer", {
  enumerable: true,
  get: function get() {
    return _ClothesDryer["default"];
  }
});
Object.defineProperty(exports, "Computer", {
  enumerable: true,
  get: function get() {
    return _Computer["default"];
  }
});
Object.defineProperty(exports, "Conditioner", {
  enumerable: true,
  get: function get() {
    return _Conditioner["default"];
  }
});
Object.defineProperty(exports, "Crockery", {
  enumerable: true,
  get: function get() {
    return _Crockery["default"];
  }
});
Object.defineProperty(exports, "Deckchairs", {
  enumerable: true,
  get: function get() {
    return _Deckchairs["default"];
  }
});
Object.defineProperty(exports, "DvdPlayer", {
  enumerable: true,
  get: function get() {
    return _DvdPlayer["default"];
  }
});
Object.defineProperty(exports, "ExtraBed", {
  enumerable: true,
  get: function get() {
    return _ExtraBed["default"];
  }
});
Object.defineProperty(exports, "Fan", {
  enumerable: true,
  get: function get() {
    return _Fan["default"];
  }
});
Object.defineProperty(exports, "Fireplace", {
  enumerable: true,
  get: function get() {
    return _Fireplace["default"];
  }
});
Object.defineProperty(exports, "Frige", {
  enumerable: true,
  get: function get() {
    return _Frige["default"];
  }
});
Object.defineProperty(exports, "FruitOnArrival", {
  enumerable: true,
  get: function get() {
    return _FruitOnArrival["default"];
  }
});
Object.defineProperty(exports, "GameConsole", {
  enumerable: true,
  get: function get() {
    return _GameConsole["default"];
  }
});
Object.defineProperty(exports, "Garden", {
  enumerable: true,
  get: function get() {
    return _Garden["default"];
  }
});
Object.defineProperty(exports, "Gift", {
  enumerable: true,
  get: function get() {
    return _Gift["default"];
  }
});
Object.defineProperty(exports, "Hall", {
  enumerable: true,
  get: function get() {
    return _Hall["default"];
  }
});
Object.defineProperty(exports, "Heating", {
  enumerable: true,
  get: function get() {
    return _Heating["default"];
  }
});
Object.defineProperty(exports, "HomeTheater", {
  enumerable: true,
  get: function get() {
    return _HomeTheater["default"];
  }
});
Object.defineProperty(exports, "Included", {
  enumerable: true,
  get: function get() {
    return _Included["default"];
  }
});
Object.defineProperty(exports, "Ipad", {
  enumerable: true,
  get: function get() {
    return _Ipad["default"];
  }
});
Object.defineProperty(exports, "IpodDockingStation", {
  enumerable: true,
  get: function get() {
    return _IpodDockingStation["default"];
  }
});
Object.defineProperty(exports, "Iron", {
  enumerable: true,
  get: function get() {
    return _Iron["default"];
  }
});
Object.defineProperty(exports, "Jacuzzi", {
  enumerable: true,
  get: function get() {
    return _Jacuzzi["default"];
  }
});
Object.defineProperty(exports, "Kitchen", {
  enumerable: true,
  get: function get() {
    return _Kitchen["default"];
  }
});
Object.defineProperty(exports, "KitchenAppliances", {
  enumerable: true,
  get: function get() {
    return _KitchenAppliances["default"];
  }
});
Object.defineProperty(exports, "Laminate", {
  enumerable: true,
  get: function get() {
    return _Laminate["default"];
  }
});
Object.defineProperty(exports, "LocationInAnexBuilding", {
  enumerable: true,
  get: function get() {
    return _LocationInAnexBuilding["default"];
  }
});
Object.defineProperty(exports, "LocationInTheNewBuilding", {
  enumerable: true,
  get: function get() {
    return _LocationInTheNewBuilding["default"];
  }
});
Object.defineProperty(exports, "Lounge", {
  enumerable: true,
  get: function get() {
    return _Lounge["default"];
  }
});
Object.defineProperty(exports, "MiniBar", {
  enumerable: true,
  get: function get() {
    return _MiniBar["default"];
  }
});
Object.defineProperty(exports, "Mirror", {
  enumerable: true,
  get: function get() {
    return _Mirror["default"];
  }
});
Object.defineProperty(exports, "Moquette", {
  enumerable: true,
  get: function get() {
    return _Moquette["default"];
  }
});
Object.defineProperty(exports, "MoreSpace", {
  enumerable: true,
  get: function get() {
    return _MoreSpace["default"];
  }
});
Object.defineProperty(exports, "NewspapersAndMagazines", {
  enumerable: true,
  get: function get() {
    return _NewspapersAndMagazines["default"];
  }
});
Object.defineProperty(exports, "OrthopedicMattress", {
  enumerable: true,
  get: function get() {
    return _OrthopedicMattress["default"];
  }
});
Object.defineProperty(exports, "Pantry", {
  enumerable: true,
  get: function get() {
    return _Pantry["default"];
  }
});
Object.defineProperty(exports, "Parking", {
  enumerable: true,
  get: function get() {
    return _Parking["default"];
  }
});
Object.defineProperty(exports, "Parquet", {
  enumerable: true,
  get: function get() {
    return _Parquet["default"];
  }
});
Object.defineProperty(exports, "Patio", {
  enumerable: true,
  get: function get() {
    return _Patio["default"];
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function get() {
    return _Phone["default"];
  }
});
Object.defineProperty(exports, "Plate", {
  enumerable: true,
  get: function get() {
    return _Plate["default"];
  }
});
Object.defineProperty(exports, "Pool", {
  enumerable: true,
  get: function get() {
    return _Pool["default"];
  }
});
Object.defineProperty(exports, "PrivateEntrance", {
  enumerable: true,
  get: function get() {
    return _PrivateEntrance["default"];
  }
});
Object.defineProperty(exports, "Radio", {
  enumerable: true,
  get: function get() {
    return _Radio["default"];
  }
});
Object.defineProperty(exports, "RollawayBed", {
  enumerable: true,
  get: function get() {
    return _RollawayBed["default"];
  }
});
Object.defineProperty(exports, "RoomService", {
  enumerable: true,
  get: function get() {
    return _RoomService["default"];
  }
});
Object.defineProperty(exports, "Safe", {
  enumerable: true,
  get: function get() {
    return _Safe["default"];
  }
});
Object.defineProperty(exports, "Sauna", {
  enumerable: true,
  get: function get() {
    return _Sauna["default"];
  }
});
Object.defineProperty(exports, "Seaview", {
  enumerable: true,
  get: function get() {
    return _Seaview["default"];
  }
});
Object.defineProperty(exports, "SeveralBedrooms", {
  enumerable: true,
  get: function get() {
    return _SeveralBedrooms["default"];
  }
});
Object.defineProperty(exports, "SharedBathroom", {
  enumerable: true,
  get: function get() {
    return _SharedBathroom["default"];
  }
});
Object.defineProperty(exports, "SharedShower", {
  enumerable: true,
  get: function get() {
    return _SharedShower["default"];
  }
});
Object.defineProperty(exports, "SharedToilet", {
  enumerable: true,
  get: function get() {
    return _SharedToilet["default"];
  }
});
Object.defineProperty(exports, "Shower", {
  enumerable: true,
  get: function get() {
    return _Shower["default"];
  }
});
Object.defineProperty(exports, "Simulators", {
  enumerable: true,
  get: function get() {
    return _Simulators["default"];
  }
});
Object.defineProperty(exports, "Sofa", {
  enumerable: true,
  get: function get() {
    return _Sofa["default"];
  }
});
Object.defineProperty(exports, "Soundproofing", {
  enumerable: true,
  get: function get() {
    return _Soundproofing["default"];
  }
});
Object.defineProperty(exports, "Svg2Balconies", {
  enumerable: true,
  get: function get() {
    return _Balconies["default"];
  }
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _Table["default"];
  }
});
Object.defineProperty(exports, "TeaSet", {
  enumerable: true,
  get: function get() {
    return _TeaSet["default"];
  }
});
Object.defineProperty(exports, "Tile", {
  enumerable: true,
  get: function get() {
    return _Tile["default"];
  }
});
Object.defineProperty(exports, "Toilet", {
  enumerable: true,
  get: function get() {
    return _Toilet["default"];
  }
});
Object.defineProperty(exports, "Toiletry", {
  enumerable: true,
  get: function get() {
    return _Toiletry["default"];
  }
});
Object.defineProperty(exports, "Tv", {
  enumerable: true,
  get: function get() {
    return _Tv["default"];
  }
});
Object.defineProperty(exports, "Wardrobe", {
  enumerable: true,
  get: function get() {
    return _Wardrobe["default"];
  }
});
Object.defineProperty(exports, "WashingMachine", {
  enumerable: true,
  get: function get() {
    return _WashingMachine["default"];
  }
});
Object.defineProperty(exports, "WiFi", {
  enumerable: true,
  get: function get() {
    return _WiFi["default"];
  }
});
var _Balconies = _interopRequireDefault(require("./2Balconies"));
var _Balcony = _interopRequireDefault(require("./Balcony"));
var _Bathrobes = _interopRequireDefault(require("./Bathrobes"));
var _BathroomFloorScales = _interopRequireDefault(require("./BathroomFloorScales"));
var _Bathroom = _interopRequireDefault(require("./Bathroom"));
var _Bbq = _interopRequireDefault(require("./Bbq"));
var _Bidet = _interopRequireDefault(require("./Bidet"));
var _BungalowLocation = _interopRequireDefault(require("./BungalowLocation"));
var _BunkBed = _interopRequireDefault(require("./BunkBed"));
var _Butler = _interopRequireDefault(require("./Butler"));
var _Cabinet = _interopRequireDefault(require("./Cabinet"));
var _Canteen = _interopRequireDefault(require("./Canteen"));
var _Carpet = _interopRequireDefault(require("./Carpet"));
var _ChangeOfClothes = _interopRequireDefault(require("./ChangeOfClothes"));
var _ChildrensBed = _interopRequireDefault(require("./ChildrensBed"));
var _Cleaning = _interopRequireDefault(require("./Cleaning"));
var _ClothesDryer = _interopRequireDefault(require("./ClothesDryer"));
var _Computer = _interopRequireDefault(require("./Computer"));
var _Conditioner = _interopRequireDefault(require("./Conditioner"));
var _Crockery = _interopRequireDefault(require("./Crockery"));
var _Deckchairs = _interopRequireDefault(require("./Deckchairs"));
var _DvdPlayer = _interopRequireDefault(require("./DvdPlayer"));
var _ExtraBed = _interopRequireDefault(require("./ExtraBed"));
var _Fan = _interopRequireDefault(require("./Fan"));
var _Fireplace = _interopRequireDefault(require("./Fireplace"));
var _Frige = _interopRequireDefault(require("./Frige"));
var _FruitOnArrival = _interopRequireDefault(require("./FruitOnArrival"));
var _GameConsole = _interopRequireDefault(require("./GameConsole"));
var _Garden = _interopRequireDefault(require("./Garden"));
var _Gift = _interopRequireDefault(require("./Gift"));
var _Hall = _interopRequireDefault(require("./Hall"));
var _Heating = _interopRequireDefault(require("./Heating"));
var _HomeTheater = _interopRequireDefault(require("./HomeTheater"));
var _Included = _interopRequireDefault(require("./Included"));
var _Ipad = _interopRequireDefault(require("./Ipad"));
var _IpodDockingStation = _interopRequireDefault(require("./IpodDockingStation"));
var _Iron = _interopRequireDefault(require("./Iron"));
var _Jacuzzi = _interopRequireDefault(require("./Jacuzzi"));
var _KitchenAppliances = _interopRequireDefault(require("./KitchenAppliances"));
var _Kitchen = _interopRequireDefault(require("./Kitchen"));
var _Laminate = _interopRequireDefault(require("./Laminate"));
var _LocationInAnexBuilding = _interopRequireDefault(require("./LocationInAnexBuilding"));
var _LocationInTheNewBuilding = _interopRequireDefault(require("./LocationInTheNewBuilding"));
var _Lounge = _interopRequireDefault(require("./Lounge"));
var _MiniBar = _interopRequireDefault(require("./MiniBar"));
var _Mirror = _interopRequireDefault(require("./Mirror"));
var _Moquette = _interopRequireDefault(require("./Moquette"));
var _MoreSpace = _interopRequireDefault(require("./MoreSpace"));
var _NewspapersAndMagazines = _interopRequireDefault(require("./NewspapersAndMagazines"));
var _OrthopedicMattress = _interopRequireDefault(require("./OrthopedicMattress"));
var _Pantry = _interopRequireDefault(require("./Pantry"));
var _Parking = _interopRequireDefault(require("./Parking"));
var _Parquet = _interopRequireDefault(require("./Parquet"));
var _Patio = _interopRequireDefault(require("./Patio"));
var _Phone = _interopRequireDefault(require("./Phone"));
var _Plate = _interopRequireDefault(require("./Plate"));
var _Pool = _interopRequireDefault(require("./Pool"));
var _PrivateEntrance = _interopRequireDefault(require("./PrivateEntrance"));
var _Radio = _interopRequireDefault(require("./Radio"));
var _RollawayBed = _interopRequireDefault(require("./RollawayBed"));
var _RoomService = _interopRequireDefault(require("./RoomService"));
var _Safe = _interopRequireDefault(require("./Safe"));
var _Sauna = _interopRequireDefault(require("./Sauna"));
var _Seaview = _interopRequireDefault(require("./Seaview"));
var _SeveralBedrooms = _interopRequireDefault(require("./SeveralBedrooms"));
var _SharedBathroom = _interopRequireDefault(require("./SharedBathroom"));
var _SharedShower = _interopRequireDefault(require("./SharedShower"));
var _SharedToilet = _interopRequireDefault(require("./SharedToilet"));
var _Shower = _interopRequireDefault(require("./Shower"));
var _Simulators = _interopRequireDefault(require("./Simulators"));
var _Sofa = _interopRequireDefault(require("./Sofa"));
var _Soundproofing = _interopRequireDefault(require("./Soundproofing"));
var _Table = _interopRequireDefault(require("./Table"));
var _TeaSet = _interopRequireDefault(require("./TeaSet"));
var _Tile = _interopRequireDefault(require("./Tile"));
var _Toilet = _interopRequireDefault(require("./Toilet"));
var _Toiletry = _interopRequireDefault(require("./Toiletry"));
var _Tv = _interopRequireDefault(require("./Tv"));
var _Wardrobe = _interopRequireDefault(require("./Wardrobe"));
var _WashingMachine = _interopRequireDefault(require("./WashingMachine"));
var _WiFi = _interopRequireDefault(require("./WiFi"));